import { useDispatch } from 'react-redux';

import { TDispatch } from 'shared/common/types/redux';

export const useAppDispatch: () => TDispatch = useDispatch;
